import React from "react";
import { WORKFLOW_NOTIFY_USER_CUSTOM_VIEW_KEY } from "../constants/workflowConstants";
import type { FormFieldDefinition } from "../types/workflowFormField";
import type { StepFormProps } from "../types/workflowSharedTypes";
import { AutomatedResponseForm } from "../components/AutomatedResponseForm";
import { CreateLeadActionForm, DelayActionForm } from "../components/CustomActionComponents";

export type { StepFormProps } from "../types/workflowSharedTypes";

export interface ActionFormRegistryEntry {
    formFields?: FormFieldDefinition[];
    customComponent?: React.ComponentType<StepFormProps & Record<string, unknown>>;
}

export const ACTION_FORM_REGISTRY: Record<string, ActionFormRegistryEntry> = {
    "Action.Message.AutomatedResponse": {
        customComponent: AutomatedResponseForm,
    },
    "Action.Crm.CreateLead": {
        customComponent: CreateLeadActionForm,
    },
    "Action.FlowControl.Delay": {
        customComponent: DelayActionForm,
    },
};

export const CUSTOM_VIEW_ALLOWLIST: Record<
    string,
    React.LazyExoticComponent<React.ComponentType<StepFormProps & Record<string, unknown>>>
> = {
    [WORKFLOW_NOTIFY_USER_CUSTOM_VIEW_KEY]: React.lazy(() => import("../components/NotifyUserCustomView")),
};
